import React from "react";
import cls from "./styles.module.scss";

interface ButtonProps {
  label?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const GlowingButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      type="button"
      className={cls.wrapper}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={cls.bg} />
      <div className={cls.main}>{label}</div>
    </button>
  );
};
